import * as r from 'runtypes';

// ANSWERS
export const CertificateSectionQuestionAnswersOptionsRuntype = r.Record({
    guid: r.String,
    is_correct: r.Boolean.optional(),
});
export type CertificateSectionQuestionAnswersOptions = r.Static<typeof CertificateSectionQuestionAnswersOptionsRuntype>;

export const CertificateSectionQuestionAnswersRuntype = r.Record({
    answer: r.String.optional(),
    is_answer_correct: r.Boolean.optional(),
    options: r.Array(CertificateSectionQuestionAnswersOptionsRuntype).optional(),
});
export type CertificateSectionQuestionAnswers = r.Static<typeof CertificateSectionQuestionAnswersRuntype>;

export const CertificateSectionAnswersRuntype = r.Record({
    answers_map: r.Dictionary(CertificateSectionQuestionAnswersRuntype, r.String),
    is_checked: r.Boolean,
});
export type CertificateSectionAnswers = r.Static<typeof CertificateSectionAnswersRuntype>;

// CORE MODELS
export const CertificateRuntype = r.Record({
    guid: r.String,
    created_at: r.Number,
    assigned_at: r.Number.nullable(),
});
export type Certificate = r.Static<typeof CertificateRuntype>;

export const CertificateSectionTopicRuntype = r.Record({
    guid: r.String,
    title: r.String,
    heading: r.String,
    subheading: r.String,
    body: r.String,
});
export type CertificateSectionTopic = r.Static<typeof CertificateSectionTopicRuntype>;

export const CertificateSectionQuestionOptionRuntype = r.Record({
    guid: r.String,
    title: r.String,
});
export type CertificateSectionQuestionOption = r.Static<typeof CertificateSectionQuestionOptionRuntype>;

export const CertificateSectionQuestionRuntype = r.Record({
    guid: r.String,
    title: r.String,
    number: r.String.optional(),
    is_short_answer: r.Boolean,
    is_single_choice: r.Boolean,
    options: r.Array(CertificateSectionQuestionOptionRuntype),
});
export type CertificateSectionQuestion = r.Static<typeof CertificateSectionQuestionRuntype>;

export const CertificateSectionRuntype = r.Record({
    guid: r.String,
    title: r.String,
    number: r.String.optional(),
    topics: r.Array(CertificateSectionTopicRuntype),
    questions: r.Array(CertificateSectionQuestionRuntype),
    answers: CertificateSectionAnswersRuntype.optional(),
    is_complete: r.Boolean.optional(),
});
export type CertificateSection = r.Static<typeof CertificateSectionRuntype>;

// OTHER

export type QuizResult = 'pass' | 'some' | 'fail';
